import React from 'react';

const ReturnRefundPolicy = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Returns and Refunds Policy for XGO Life App</h1>
      <p className="mb-4">
        By following this Returns and Refunds Policy, customers can ensure a smooth and hassle-free return process with the Xgo Life App.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Return Eligibility</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Items can be returned within 2 days from the date of delivery.</li>
        <li>Products must be unused, in their original packaging, and in a resalable condition.</li>
        <li>Certain items, such as perishable goods, personal hygiene products, and custom-made items, are not eligible for return.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Return Process</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Initiate a Return:</strong> To initiate a return, log into your account on the Xgo Life App and navigate to the "Orders" section. Select the order containing the item you wish to return and follow the prompts to start the return process.</li>
        <li><strong>Provide Details:</strong> Include your reason for the return and any additional information required.</li>
        <li><strong>Return Authorization:</strong> You will receive a return authorization number and instructions on how to return the item.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Shipping Returns</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Return Shipping Costs:</strong> Customers are responsible for return shipping costs unless the item is defective or the wrong item was sent. In such cases, Xgo Life will cover the return shipping.</li>
        <li><strong>Packaging:</strong> Ensure that the item is securely packaged to prevent damage during transit. Include all original packaging, accessories, and documentation.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Refund Process</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Processing Time:</strong> Once the returned item is received and inspected, the refund will be processed within 5-7 business days. You will receive a confirmation email once the refund is initiated.</li>
        <li><strong>Refund Method:</strong> Refunds will be issued to the original payment method used at the time of purchase. Please note that it may take additional time for your bank or payment provider to process and post the refund.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Exchanges</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Exchange Requests:</strong> If you wish to exchange an item for a different size or color, please follow the return process and indicate that you would like an exchange. You may need to place a new order for the replacement item.</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Defective or Damaged Items</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Report Issues Promptly:</strong> If you receive a defective or damaged item, contact customer support within 48 hours of delivery to report the issue.</li>
        <li><strong>Refund or Replacement:</strong> Depending on your preference, you can choose to receive a full refund or a replacement for the defective item.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. Final Sale Items</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Items marked as final sale or non-returnable cannot be returned or refunded. This includes clearance items, special orders, and personalized products.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. Customer Support</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>For any questions or assistance regarding returns and refunds, please contact our customer support team through the app or website. We are here to help!</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Policy Updates</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Xgo Life reserves the right to update or modify this Returns and Refunds Policy at any time. Customers will be notified of significant changes via email or through the app.</li>
      </ul>
    </div>
  );
};

export default ReturnRefundPolicy;